module.exports = __webpack_public_path__ + "assets/images/project/flag.svg?v=2c5501c9";